var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "card bg-secondary border-0 mb-0 shadow-none" },
      [
        _c("div", { staticClass: "card-header bg-transparent pb-5 border-0" }, [
          _c(
            "div",
            { staticClass: "logo-center text-center mb-4 pb-4 border-bottom" },
            [
              _c("img", {
                staticClass: "icon-logo",
                attrs: { src: require("@/assets/img/brand/logo.svg") },
              }),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }